import { style } from 'typestyle'
export const mr16 = style({ marginRight: '16px' })
